import React, { useState } from 'react';
import { Button, Input, Row, Col, Form, Select } from 'antd';
import APIService from '../../Service/APIService';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from '../AuthProvider.js';

const ASUserDetails = () => {
  const { user, isReady } = useAuth();
  const navigate = useNavigate();
  const userType = user?.Type;
  const params = useParams();

  const [ASUser, setASUser] = useState(null);
  const [isEditable, setIsEditable] = useState(false);
  const [fName, setFName] = useState('');
  const [lName, setLName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('');
  const [region, setRegion] = useState(null);
  const [regionsData, setRegionsData] = useState([]);

  const getRegionData = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend('getallregions');
    const tempData = response?.data?.data?.map((item) => ({
      value: item.ID,
      label: item.Region,
    })) || [];
    setRegionsData(tempData);
    return tempData;
  };

  const getASUserDetails = async (availableRegions = []) => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(`getasuserbyid?ID=${params?.id}`);
    const userData = response?.data?.data;

    console.log('AS User Details: ', response);
    setFName(userData?.FirstName || '');
    setLName(userData?.LastName || '');
    setPhone(userData?.Phone || '');
    setEmail(userData?.Email || '');
    setRole(userData?.RoleType || '');
    setASUser(userData);

    const resolvedRegionName = userData?.RegionName || userData?.Region || '';
    const resolvedRegionId = userData?.RegionID ?? null;
    const matchedRegion =
      availableRegions.find((item) => item.value === resolvedRegionId) ||
      (resolvedRegionName
        ? {
            value: resolvedRegionId,
            label: resolvedRegionName,
          }
        : null);

    setRegion(matchedRegion);
  };

  React.useEffect(() => {
    if (!isReady) {
      return;
    }

    if (userType !== 'Admin') {
      navigate('/', { replace: true });
      return;
    }

    const loadPageData = async () => {
      const availableRegions = await getRegionData();
      await getASUserDetails(availableRegions);
    };

    loadPageData();
  }, [isReady, userType, navigate, params?.id]);

  const handleEditClick = async () => {
    if (!isEditable) {
      setIsEditable(true);
      return;
    }

    if (!fName || !lName || !email || !phone || !role) {
      Swal.fire({
        icon: 'error',
        title: 'Missing Fields',
        text: 'Please fill all required fields before saving.',
      });
      return;
    }

    if (role === 'ASD' && !region?.value) {
      Swal.fire({
        icon: 'error',
        title: 'Missing Region',
        text: 'Please select a region for an ASD user.',
      });
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to update the user details.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const apiServe = new APIService();
        const payload = {
          ID: ASUser?.UserID,
          Prefix: ASUser?.Prefix || null,
          FirstName: fName,
          LastName: lName,
          Email: email,
          Phone: phone,
          Type: role,
          RoleType: role,
          RegionID: role === 'ASD' ? region?.value : null,
          RegionName: role === 'ASD' ? region?.label : null,
        };

        try {
          const response = await apiServe.updateDataToBackend(payload, 'updateasuser');
          if (response?.status === 200 || response?.status === 201) {
            Swal.fire({
              icon: 'success',
              title: 'User Updated',
              text: 'User details have been updated successfully.',
            });
            setIsEditable(false);
            await getASUserDetails(regionsData);
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: response?.data?.message || 'An error has occurred while updating the user.',
            });
          }
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error?.response?.data?.message || 'An error has occurred while updating the user.',
          });
        }
      }
    });
  };

  const deleteUser = async () => {
    console.log("Delete User");
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const apiServe = new APIService();
        const response = await apiServe.updateDataToBackend({},`deleteasuser?ID=${ASUser?.UserID}`);
        console.log("Delete AS User: ", response);
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire({
            icon: 'success',
            title: 'User Deleted',
            text: 'User has been deleted successfully',
          }).then(() => {
            navigate('/ASUsers');
          });
        } 
        else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'An error has occurred',
          }).then(() => {
            window.location.reload();
          });
        }
      }
    });
  }

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px',
        }}
      >
        <div className='row'>
          <div style={{ fontWeight: '400', fontSize: '16px', lineHeight: '24px' }}>AS Users</div>
          <div style={{ fontWeight: '600', fontSize: '32px', marginTop: '8px' }}>{userType}</div>
        </div>

        {/* <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className='row' style={{ marginRight: '15px' }}>
            <div style={{ fontWeight: '400', fontSize: '16px', lineHeight: '24px', marginBottom: '4px' }}>Logged in as Admin</div>
            <div style={{ fontWeight: '600', fontSize: '18px', lineHeight: '21.78px', textAlign: 'end' }}>User</div>
          </div>
          <div style={{ fontWeight: 'bold' }}>
            <LogoutOutlined style={{ fontSize: '26px' }} />
          </div>
        </div> */}
      </div>
      {userType === "Admin" &&
        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '40px 0px 30px 0px' }}>
          <Button type='primary' style={{ background: isEditable ? '#27a907' : '#ff9202' }} onClick={handleEditClick}>
            {isEditable ? 'Save Changes' : 'Edit'}
          </Button>

          <Button type='primary' onClick={() => deleteUser()} style={{ background: '#ff0000' }}>
            Delete User
          </Button>
        </div>
      }
      <div>
        <Form layout='vertical'>

          <Row gutter={16}>
            <Col span={6}>
              <Form.Item label='First Name'>
                <Input value={fName} onChange={(e) => setFName(e.target.value)} disabled={!isEditable} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label='Last Name'>
                <Input value={lName} onChange={(e) => setLName(e.target.value)} disabled={!isEditable} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item label='Phone'>
                <Input value={phone} onChange={(e) => setPhone(e.target.value)} disabled={!isEditable} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label='Email'>
                <Input value={email} onChange={(e) => setEmail(e.target.value)} disabled={!isEditable} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={6}>
              <Form.Item label='Role'>
                <Select
                  value={role || undefined}
                  disabled={!isEditable}
                  onChange={(value) => {
                    setRole(value);
                    if (value !== 'ASD') {
                      setRegion(null);
                    }
                  }}
                  options={[
                    { value: 'Admin', label: 'Admin' },
                    { value: 'Viewer', label: 'Viewer' },
                    { value: 'ASD', label: 'ASD' },
                    { value: 'Authorizer', label: 'Authorizer' },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label='Region'>
                <Select
                  value={role === 'ASD' ? region?.value : undefined}
                  disabled={!isEditable || role !== 'ASD'}
                  onChange={(value, option) => setRegion(option)}
                  options={regionsData}
                  placeholder={role === 'ASD' ? 'Select Region' : 'Region not required'}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default ASUserDetails;
